import api from "./api";

const baseURL = process.env.REACT_APP_CORE_REGISTRY;

export async function list(text) {
    return await api.get(`${baseURL}/api/v1/usuarios?text=${text}`);
}

export async function create(data) {
    return await api.post(`${baseURL}/api/v1/usuarios`, data);
}

export async function update(data) {
    return await api.put(`${baseURL}/api/v1/usuarios`, data);
}

export async function get(id) {
    return await api.get(`${baseURL}/api/v1/usuarios/${id}`);
}

export async function remove(id) {
    return await api.delete(`${baseURL}/api/v1/usuarios/${id}`);
}

export async function listByAreaNegocio(id) {
    return await api.get(`${baseURL}/api/v1/usuarios/areas-negocio/${id}`);
}

export async function autenticar(data) {
    return await api.post(`${baseURL}/api/v1/usuarios/autenticar`, data);
}

export async function listCatalogs() {
    return await api.get(`${baseURL}/api/v1/usuarios/catalogs`);
}

export async function switchCatalog(catalogName) {
    return await api.post(`${baseURL}/api/v1/usuarios/switch-catalog`, { catalogName });
}
